import { render, staticRenderFns } from "./IconTaskAction.vue?vue&type=template&id=50ca7bf1&"
import script from "./IconTaskAction.vue?vue&type=script&lang=ts&"
export * from "./IconTaskAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports